import { useState } from "react";
import { getFormattedDate, toProperCase } from "../../../Utils";
import { MATERIAL_TABLE_COLUMNS, PAYMENT_TIMELINE_COLUMNS, POPUP_TABS, TABS } from "../constants";
import { FaTimes, FaTimesCircle } from "react-icons/fa";

const PreviewPopup = ({ popUpData, onClose, onConfirm }) => {
  const [activeTab, setActiveTab] = useState(POPUP_TABS.PROJECT_TAB);

  if (!popUpData) return null;

  const { client_project_details, payment_timelines, materials } = popUpData;

  const tabContent = {
    [POPUP_TABS.PROJECT_TAB]: (
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 text-sm">
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">
              Project Name
            </span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.project_name || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">
              Client Name
            </span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.client_name || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Phone</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.client_phone || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Capacity</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.capacity_kw || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Type</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.type || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Address</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.client_address || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">
              Start Date
            </span>{" "}
            <span className="font-semibold">
              {getFormattedDate(
                client_project_details?.[0]?.estimated_start_date
              ) || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">End Date</span>{" "}
            <span className="font-semibold">
              {getFormattedDate(
                client_project_details?.[0]?.estimated_end_date
              ) || "N/A"}
            </span>
          </p>
        </div>
        {/* Payment Timelines */}
        <div className="w-full">
          <h3 className="text-lg font-semibold text-secondary mb-2">
            Payment Timelines
          </h3>
          <div className="border rounded md:h-[200px] h-[200px] overflow-y-auto">
            <table className="w-full border-collapse text-sm">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  {PAYMENT_TIMELINE_COLUMNS.map((item) => (
                    <th key={item.key} className={item.commonCSS}>
                      {item.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {payment_timelines.map((pay, idx) => (
                  <tr key={idx} className="text-center">
                    <td className="p-2 border">{pay.project_name || "N/A"}</td>
                    <td className="p-2 border">{pay.amount || "N/A"}</td>
                    <td className="p-2 border">
                      {pay.payment_status || "N/A"}
                    </td>
                    <td className="p-2 border">
                      {getFormattedDate(pay.payment_date) || "N/A"}
                    </td>
                    <td className="p-2 border">
                      {pay.phase_description || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ),

    [POPUP_TABS.MATERIAL_TAB]: (
      <div className="border md:h-[300px] h-[400px]  overflow-y-auto rounded">
        <table className="w-full border-collapse text-sm">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              {MATERIAL_TABLE_COLUMNS.map((item, key) => (
                <th className={item.commonCSS} key={key}>{item.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {materials.map((mat, idx) => (
              <tr key={idx} className="text-center">
                <td className="p-2 border">{mat.project_name || "N/A"}</td>
                <td className="p-2 border">{mat.material_name || "N/A"}</td>
                <td className="p-2 border">{mat.quantity || "N/A"}</td>
                <td className="p-2 border">{mat.specification || "N/A"}</td>
                <td className="p-2 border">{mat.unit || "N/A"}</td>
                <td className="p-2 border">
                  {getFormattedDate(mat.delivery_date) || "N/A"}
                </td>
                <td className="p-2 border">
                  {toProperCase(mat.status) || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),

    [POPUP_TABS.VENDOR_TAB]: (
      <div className="space-y-3 h-full overflow-y-hidden">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 text-sm">
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Name</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_name || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Email</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_email || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Phone</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_phone || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">Address</span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_address || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">
              Vendor Representative
            </span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_representative || "N/A"}
            </span>
          </p>
          <p className="flex flex-col ">
            <span className="font-medium text-gray-700 text-xs">
              Vendor Designation
            </span>{" "}
            <span className="font-semibold">
              {client_project_details?.[0]?.vendor_designation || "N/A"}
            </span>
          </p>
        </div>
      </div>
    ),
  };

return (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white rounded-2xl shadow-lg w-11/12 max-w-5xl md:h-[90vh] h-[70vh] py-6 px-4 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl text-secondary font-semibold">
          Preview Project
        </h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-red-500 text-lg"
        >
          <FaTimes />
        </button>
      </div>

      {/* Tabs */}
      <div className="flex border-b mb-4">
        {TABS.map((item) => (
          <button
            key={item.key}
            className={`px-4 py-2 font-medium text-xs md:text-sm ${
              activeTab === item.key
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="flex-1 pr-2">
        {tabContent[activeTab]}
      </div>

      {/* Footer */}
      <div className="flex justify-end text-sm gap-3 mt-4">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={() => onConfirm(popUpData)}
          className="px-4 py-2 rounded-lg bg-secondary text-white hover:bg-gray-800"
        >
          Confirm Upload
        </button>
      </div>
    </div>
  </div>
);
};

export default PreviewPopup;
